import { useContext } from 'react';

import { CustomerWebSocketContext } from '../../contexts/auth.contexts';

export const useCustomerWebSocket = () => {
  const ctx = useContext(CustomerWebSocketContext);
  if (!ctx) throw new Error('WebSocketProvider missing');
  return ctx;
};
